import React from "react";
import { useContent } from "../context/ContentContext";

export default function About() {
  const { content } = useContent();
  const a = content.about || {};
  const values = a.values || [];
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{a.title || "About Himmelstor Farm"}</h1>
      <p>{a.intro || ""}</p>
      <h3 className="mt-4 text-warning">Vision</h3>
      <p>{a.vision || ""}</p>
      <h3 className="mt-4 text-warning">Mission</h3>
      <p>{a.mission || ""}</p>
      <h3 className="mt-4 text-warning">Core Values</h3>
      <ul>
        {values.map((v, i) => <li key={i}>{v}</li>)}
      </ul>
      <h3 className="mt-4 text-warning">Farming Philosophy</h3>
      <p>{a.philosophy || ""}</p>
      <h3 className="mt-4 text-warning">Founder & Management</h3>
      <p>{a.founder || ""}</p>
      <h3 className="mt-4 text-warning">Certifications & Partnerships</h3>
      <p>{a.certifications || ""}</p>
    </div>
  );
}
